import { SxProps } from '@mui/material';
import theme from '@theme/index';

const { palette } = theme;

const styles: Record<string, SxProps> = {
  drawerContainer: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    pb: '2.5rem',
    '.link-component': {
      textDecoration: 'underlined',
      color: palette.primary.main,
      fontWeight: '400'
    }
  },

  mainHeading: {
    color: palette.primary.main,
    fontSize: {
      xs: '1.25rem',
      md: '1.5rem'
    },
    mb: '1rem'
  },
  smallHeading: {
    fontSize: '1.25rem'
  },
  paragraph: {
    color: palette.grey.main,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    mt: '0.5rem'
  },
  spanText: {
    fontSize: {
      xs: '1.25rem',
      md: '1.5rem'
    },
    fontWeight: 700
  },
  divider: {
    my: '1.5rem',
    borderColor: `${palette.primary['300']}80`
  },

  viewFeeBtn: {
    width: 'fit-content',
    mt: { xs: '1rem', md: '2rem' },
    textTransform: 'none',
    fontSize: '1rem'
  },

  footerBtn: {
    mt: '2rem'
  },

  feeText: {
    fontSize: {
      xs: '1rem',
      md: '0.875rem'
    },
    lineHeight: '1.25rem',
    fontWeight: 400,
    py: '1rem'
  },

  internalBox: {
    border: `0.063rem solid ${palette.secondary['600']}`,
    borderRadius: '0.5rem',
    background: palette.grey['50'],
    padding: {
      xs: '1rem',
      md: '1rem'
    }
  },

  btnContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    width: { xs: '100%', sm: 'auto' },
    pt: '1rem'
  }
};

export default styles;
